import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Remet la fenêtre en haut à chaque changement de page (pathname).
 * Corrige le comportement par défaut de React Router qui conserve
 * la position de scroll lors d'une navigation.
 *
 * On force `behavior: 'instant'` pour outrepasser le `scroll-smooth`
 * appliqué sur <html> dans le CSS global : sans cela, l'animation de
 * défilement est interrompue par le démontage de l'ancienne page et
 * n'atteint pas le haut de façon fiable.
 *
 * On ne réagit qu'au `pathname` (pas à `search`) pour ne pas perturber
 * les pages dont les filtres sont persistés dans l'URL (ex: recherche,
 * sélection de compte). Si un hash d'ancre est présent, on laisse le
 * navigateur gérer le défilement vers l'élément ciblé.
 *
 * `useLayoutEffect` : le repositionnement a lieu avant le premier
 * rendu peint de la nouvelle page, ce qui évite tout clignotement.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);

  return null;
}
